import { PromotionNotAvailablePageLabels } from 'libs/shared-lib/interfaces';

export const PROMOTION_NOT_AVAILABLE_LABELS_DE: PromotionNotAvailablePageLabels = {
    headline: 'Scheinbar gibt es ein Problem!',
    copyFirst: 'Es tut uns leid, die Aktion konnte nicht gefunden werden. Vermutlich ist sie abgelaufen.',
    copySecond: 'Hier findest du alle aktuellen Angebote.',
};
